<template>
    <div v-if="stripeshow" class="payment-dialog">
        
        <h2>View/Add Subscriptions</h2>
        <table style="width:100%;">
            <tr>
                <td style="width:25%;"><switcher :initial-period="defaultPeriod" :monthlycount="monthlycount" :yearlycount="yearlycount" @period-changed="handlePeriodChange" /></td>
                <td style="text-align: right;">
                    <span style="border:1px #777 solid;padding:8px;border-radius: 10px;background-color: #eee;font-size:16px;">
                        You are on the "{{ customerdata.basesub.desc }}"
                    </span>
                </td>
            </tr>
        </table>
        <br>

        <table v-if="!updating" style="width:100%;border:1px #333 solid;border-collapse: collapse;">
            <tr>
                <td style="background-color:#eee;font-weight:bold;border:1px #aaa solid;padding:6px;font-size:16px;">Subscription Product</td>
                <td style="background-color:#eee;font-weight:bold;border:1px #aaa solid;padding:6px;text-align: center;font-size:16px;">My Qty</td>
                <td style="background-color:#eee;font-weight:bold;border:1px #aaa solid;padding:6px;text-align: center;font-size:16px;">Add Qty</td>
                <td style="background-color:#eee;font-weight:bold;border:1px #aaa solid;padding:6px;text-align: center;font-size:16px;">Added {{ period.charAt(0).toUpperCase() + period.slice(1) }} Cost</td>
            </tr>
            <tr v-for="s in standardpriceset">
                <td v-if="s.period==period && s.base==customerdata.basesub.priceid" style="width:25%;border:1px #aaa solid;padding:10px;font-size:16px;">
                    {{ s.desc }}
                </td>
                <td v-if="s.period==period && s.base==customerdata.basesub.priceid" style="width:10%;border:1px #aaa solid;padding:10px;font-size:18px;text-align: center;">
                    {{ customerdata.addonsubs[s.priceid] | 0 }}
                </td>
                <template v-if="(s.maxsubs-(customerdata.addonsubs[s.priceid] | 0))==0">
                    <td v-if="s.period==period && s.base==customerdata.basesub.priceid" style="border:1px #aaa solid;padding:10px;text-align: center;font-size:18px;">
                        <span>Already at Maximum Allowed</span> 
                    </td>
                </template>
                <template v-else>
                    <td v-if="s.period==period && s.base==customerdata.basesub.priceid" style="border:1px #aaa solid;padding:10px;text-align: center;font-size:18px;">
                        <button class="addbtn" v-if="s.addqty>0" @click="s.addqty--">-</button> 
                        <span class="addnum">{{ s.addqty }}</span>
                        <button class="addbtn" v-if="s.addqty<(s.maxsubs-(customerdata.addonsubs[s.priceid] | 0))" @click="s.addqty++">+</button> 
                    </td>
                </template>
                <td v-if="s.period==period && s.base==customerdata.basesub.priceid" style="width:80px;border:1px #aaa solid;padding:10px;font-size:18px;text-align: center;">
                    ${{ (s.addqty*s.price).toFixed(2) }}
                </td>
            </tr>
        </table>

        <div v-else class="messages">{{ message }}</div>
        <br>
        
        <div v-if="total>0">
            <div style="font-weight: bold;">Choose Payment Method</div>
            <div style="border:1px #aaa solid;border-radius:4px;padding:12px;">
                <table style="width:100%;">
                    <tr v-for="(item,index) in customerdata.paymentmethods" :key="index">
                        <td><input name="paymentmethods" :id="`pm_${index}`"   :checked="selectedIndex === index" @change="selectItem(index)" type="checkbox"/></td>
                        <td style="font-family: 'Courier New', Courier, monospace;">{{ item.brand }}</td>
                        <td v-if="!intrialmode" style="font-family: 'Courier New', Courier, monospace;">**{{ item.last4 }}</td>
                        <td style="font-family: 'Courier New', Courier, monospace;">expires&nbsp;{{ item.exp }}</td>
                    </tr>
                </table><br>
                <div style="font-size: 18px;color:#777;">
                    <strong>Note:</strong> You can add/remove payment methods using Manage Payment Methods.<br><br>
                </div>
                <center><button class="portalbutton" @click="GoToPaymentPortal">Manage Payment Methods</button></center>
                <br>
            </div>
            <br>
        </div>

        <div v-if="total>0 && selectedIndex!=null">
            <input name="termsaccept" id="terms" type="checkbox" v-model="acceptterms" />   
            By checking this box and clicking 'Purchase Now,' you agree to add the subscriptions listed above for an additional cost of
            <span style="font-size:26px;font-weight: bold;">${{total.toFixed(2)}}</span> per {{ period.slice(0,-2) }}
            <span v-if="intrialmode"> after free trial mode has ended</span>
        </div>

        <div class="btns">
            <btn v-if="!updating" class="button secondary" v-text="'Close'" @click="Cancel()"></btn>
            <btn v-if="acceptterms && selectedIndex!=null && total>0 && !updating" class="button primary" v-text="'Purchase Now'" @click="Submit()"></btn>
            <span v-if="(!acceptterms | selectedIndex==null) && total>0 && !updating" class="dummybutton">Purchase Now</span>
        </div>

    </div>
</template>
  
<script setup>
    import { ref, watch } from 'vue';
    import switcher from '../dialogs/pricingtoggleswitch.vue';
    import btn from '../buttons/button.vue';
    import { useStore } from 'vuex';
    const props = defineProps({stripeshow: Boolean});
    const emit = defineEmits(['close']);
    const acceptterms = ref(false);
    const total = ref(0);
    const checkeditems = ref([])
    const period = ref("monthly");
    const updating = ref(false);
    const monthlycount = ref(0);
    const yearlycount = ref(0);
    const message = ref("Please wait while we gather some information...");
    const store = useStore();
    let user = ref(store.state.user);
    const standardpriceset = ref([])
    const customerdata = ref(
        {
            "basesub":[],
            "addonsubs":[],
            "paymentmethods":[]
        }
    );
    
    const selectedIndex = ref(null);
    const defaultPeriod = ref("monthly");
    const selectItem = (index) => {
        console.log("SELECT ITEM.....")
        if (selectedIndex.value === index) {
            selectedIndex.value = null;
        } else {
            selectedIndex.value = index;
        }
    };

    watch(
        () => standardpriceset.value.reduce((sum, item) => sum + item.price*Number(item.addqty), 0),
        (newTotal, oldTotal) => {
            total.value = newTotal;
            acceptterms.value = false;
        }
    )

    watch(
        () => selectedIndex.value, (newValue, oldValue) => {
        console.log("selected index changed",selectedIndex.value, " to value of:",newValue," from:",oldValue)
        acceptterms.value = false;
    })

    watch(
        () => props.stripeshow, (newValue, oldValue) => {
        GetCurrentSubscriptions();
    })

    function handlePeriodChange(newperiod) {
        period.value = newperiod;
    }

    function GoToPaymentPortal()
    {
        alert("This will load an external site.  Once done come back here");
        window.open('https://billing.stripe.com/p/login/test_00gg1Zaewe28e1qeUV', '_blank')
    }

    function Submit() {
        let addonpacket = {};
        let resp = [];
        standardpriceset.value.forEach(sub => {
            if(sub.addqty>0) {
                for(let i=0;i<sub.addqty;i++) {
                    resp.push(sub.priceid);
                }
            }
        })
        addonpacket.addons = resp;
        addonpacket.selectedpayment = customerdata.value.paymentmethods[selectedIndex.value].pid;
        console.log("added",addonpacket)
        SendChanges(addonpacket);
        setAllAddQty(0);
        //emit("close");
    }

    const setAllAddQty = (value) => {
        standardpriceset.value.forEach(sub => {
            sub.addqty = value
        })
    }
    function Cancel() {
        setAllAddQty(0);
        period.value = "monthly";
        checkeditems.value = []
        emit("close");
    }

    function SendChanges(packet) {
        message.value = "Please wait while we update your purchase..."
        updating.value = true;
        fetch("https://api.bopus.ai/api/payAddOn.php", {
            headers: {'Content-type': 'application/json'},
            method: 'POST',
            body: JSON.stringify({
                "customeremail": user.value.email,
                "trialdays": customerdata.value.trialdays,
                "addonarray": packet
            })
        }).then((res) => res.json()).then((response) => {
            console.log("Addon Response:",response);
            message.value = "Purchase Successful!"
            setTimeout(() => {
                updating.value = false;
                GetCurrentSubscriptions();
            }, 2000);
        }).catch((error) => {
            console.log('Looks like there was a problem adding subs: \n', error);
        });
    }

    const intrialmode = ref(0)
    function GetCurrentSubscriptions() {
        message.value = "Please wait while we gather some information..."
        updating.value = true;
        fetch("https://api.bopus.ai/api/payGetCustomerSubs.php", {
            headers: {'Content-type': 'application/json'},
            method: 'POST',
            body: JSON.stringify({
                "customeremail": user.value.email
            })
        }).then((res) => res.json()).then((response) => {
            console.log(response);
            customerdata.value.basesub.desc = response.basesub[0].desc;
            customerdata.value.basesub.subitem = response.basesub[0].subitem;
            if(response.basesub[0].trialsecondsremaining > 0) {
                intrialmode.value = true;
            } else {
                intrialmode.value = false;
            }
            customerdata.value.trialdays = response.basesub[0].trialsecondsremaining/(60*60*24)
            customerdata.value.basesub.priceid = response.basesub[0].priceid.replace("-monthly","").replace("-yearly","");
            customerdata.value.addonsubs = response.addonsubs;
            monthlycount.value = 0;
            yearlycount.value = 0;
            for (var key of Object.keys(response.addonsubs)) {
                console.log(key + " -> " + response.addonsubs[key])
                if(key.includes("monthly")) monthlycount.value += response.addonsubs[key];
                if(key.includes("yearly")) yearlycount.value += response.addonsubs[key];
            }
            customerdata.value.paymentmethods = response.paymentmethods;
            standardpriceset.value = response.standardpriceset;
            updating.value = false;
            console.log("CUSTOMERDATA",customerdata.value)
        }).catch((error) => {
            console.log('Looks like there was a problem retrieving subscriptions: \n', error);
            updating.value = false;
        });
    }
    GetCurrentSubscriptions();
</script>
  
<style lang="scss" scoped>
.dummybutton {
    border:1px #888 solid;
    border-radius:8px;
    color:#888;
    font-size: 26px;
    padding-top:4px;
}
.portalbutton {
    border:1px #888 solid;
    border-radius:8px;
    background-color: rgb(255, 255, 255);
    color:#888;
    font-size: 20px;
    padding:14px;
    cursor: pointer;
}
.no-double-select {
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none; /* Prevents mouse events */
}
.addbtn {
    width:50px;
    height:50px;
    font-size:28px;
    font-weight: bold;
    -webkit-user-select: auto;
    user-select: auto;
    border-color: #ccc;
    border-radius: 10px;
}
.addnum {
    font-size:24px;
    font-weight:bold;
    padding:10px;
}
.messages {
    text-align: center;
    font-weight: bold;
    border:1px rgb(255, 251, 126) solid;
    padding:20px;
    border-radius: 10px;
    background-color:rgb(255, 251, 126);
}
.payment-dialog {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.45);
  width: calc(100% - 32px);
  height: 90%;
  max-height:1000px;
  max-width: 840px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 32px 32px 145px;
  border-radius: 16px;
  background-color: #fff;
  z-index: 3;
  box-sizing: border-box;
  border:1px #333 solid;
  overflow-y: auto;
  h3{
    margin: 0 0 32px 0;
  }
  p{
    margin: 0 auto;
    color: #787878
  }
  .btns{
    text-align: center;
    margin-top: 40px;
    bottom: 32px;
    width: 100%;
    left: 0px;
    display: flex;
    padding: 0 32px;
    box-sizing: border-box;
    .button{
      padding: 0;
    }
    :first-child{
      width: 125px;
      margin-right: 16px;
    }
    :last-child{
      flex: 1;
    }
  }
}
@media screen and (max-width: 599px) and (orientation: portrait),
screen and (max-height: 500px) and (orientation: landscape) {
  .disabled_warning{
    padding: 16px 16px 115px;
  }
}
</style>